import React from "react";
import classNames from "classnames";

import { AscImageSource } from "@ascendnow/shared";

import AscLogo from "../../components/AscLogo/AscLogo";
import { AscPlatformLayoutPortal } from "../../components";
import AscImage from "../../components/AscImage/AscImage";
import AuthSideImage from "../../assets/images/auth-side-img.webp";
import styles from "./AscAuthFlowLayout.module.scss";

type AscAuthFlowLayoutAlignment = "left" | "right";

export interface AscAuthFlowLayoutProps {
  className?: string;
  sideImageUrl?: AscImageSource;
  sideImageAlt?: string;
  roundSideImage?: boolean;
  alignment?: AscAuthFlowLayoutAlignment;
  children?: React.ReactNode;
  contentClassName?: string;
  logoClassName?: string;
}

export default function AscAuthFlowLayout({
  className,
  children,
  sideImageUrl = AuthSideImage,
  sideImageAlt = "Authentication Step",
  alignment = "left",
  roundSideImage = false,
  contentClassName,
  logoClassName,
}: AscAuthFlowLayoutProps) {
  return (
    <div
      data-testid="asc-auth-flow-layout"
      className={classNames(
        styles.ground,
        {
          [styles.alignLeft]: alignment === "left",
          [styles.alignRight]: alignment === "right",
        },
        className
      )}
    >
      <AscPlatformLayoutPortal hideSidebarAndNavigation />
      <figure
        className={classNames(styles.sideImageContainer, {
          [styles.roundSideImage]: roundSideImage,
        })}
      >
        <AscImage
          className={styles.sideImage}
          src={sideImageUrl}
          alt={sideImageAlt}
        />
      </figure>
      <main className={classNames(styles.content, contentClassName)}>
        <div className={logoClassName}>
          <AscLogo href={null} className={styles.logo} />
        </div>
        {children}
      </main>
    </div>
  );
}
